import Extend from 'flarum/common/extenders';
import PointDetailsPage from './components/PointDetailsPage';

export default [
  new Extend.Routes() //
    .add('user.pointDetails', '/u/:username/pointDetails', PointDetailsPage),
];
